import React, { memo } from 'react'
import styles from './index.less'
import CustomNodeWrapper from '../../configuration/wrapper'
import type { JavaPluginActionNodeData } from '../types'
import type { ComponentType } from 'react'
import type { NodeProps } from 'reactflow'

function JavaPluginActionNodeRender({
  data,
  selected,
}: NodeProps<JavaPluginActionNodeData>) {
  return (
    <CustomNodeWrapper nodeData={data} selected={selected}>
      <span className={`${styles.nodeText}`}>{data.nodeName}</span>
    </CustomNodeWrapper>
  )
}

const JavaPluginActionNode: ComponentType<NodeProps<JavaPluginActionNodeData>>
  = memo(JavaPluginActionNodeRender)

export default JavaPluginActionNode
